/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../../../Common/Style/summaryStyle";
import Typography from "@mui/material/Typography";
import { AbstractCase } from "../../../../../types/Entities/AbstractCase";
import { Box } from "@mui/material";
import SummaryDetailsItem from "../../../Common/SummaryDetailsItem/SummaryDetailsItem";

type ContactDataProps = {
  formData: AbstractCase | Record<string, any>;
  product: AbstractCase;
  withInsurance?: boolean;
};

const ContactData = ({ formData, product, withInsurance = true }: ContactDataProps) => {
  const personType = "alimonyPartner";
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h5"}>Persönliche Angaben</Typography>
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={personType + ".person.gender"} sx={summaryStyle.scrollToAnchor} />
        Anrede
      </Grid>
      <Grid size={12}>
        {formData.alimonyPetitioner.person.gender === "male" ? "Herr" : "Frau"}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={personType + ".person.givenName"} sx={summaryStyle.scrollToAnchor} />
        Vorname
      </Grid>
      <Grid size={12}>
        {formData.alimonyPetitioner.person.givenName}
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={personType + ".person.familyName"} sx={summaryStyle.scrollToAnchor} />
        Nachname
      </Grid>
      <Grid size={12}>
        {formData.alimonyPetitioner.person.familyName}
      </Grid>
      <SummaryDetailsItem fieldPath={"customer.telephone"} caseData={product} />
      {withInsurance && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"insurancePolicyNumber"} sx={summaryStyle.scrollToAnchor} />
            Versichertennummer
          </Grid>
          <Grid size={12}>
            {formData.caseInsurance.insurancePolicyNumber}
          </Grid>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"caseReferenceNumber"} sx={summaryStyle.scrollToAnchor} />
            Schadennummer
          </Grid>
          <Grid size={12}>
            {formData.caseInsurance.caseReferenceNumber}
          </Grid>
        </>
      )}
    </>
  );
};

export default ContactData;
